<template>
	<div class="container-list">
		<div class="common-page common-head">
			<div class="common-page common-head-title">
				<i class="icon-tr-other"></i>
				建筑分区信息
			</div>
		</div>
		<div class="ml20  f18 blue cursor">
			<i class="el-icon-back" @click="$router.back()">返回</i>
			<div class="flr" style="float:right"></div>
		</div>
		<div class="flex mt20" style="border-bottom: 1px solid #ccc;padding-bottom:20px">
			<div class="ml20" @click="showDia = true">
				<el-button icon="el-icon-plus" type="primary" size="small" @click="addBuild()">添加一次分区</el-button>
			</div>
			<el-button type="primary" class="ml20" @click="onSubmit" size="small" v-hasPermi="['drillplan:planJianzhu:addAndUpdate']">保存分区</el-button>
		</div>

		<el-form class="mt20" ref="form" :model="partition" label-width="110px">
			<el-row class="mt20" :gutter="20" style="border-bottom: 1px solid #ccc" v-for="(item, index) in form.planJianzhuList" :key="index">
				<div class="flex" style="justify-content: flex-end">
					<el-button class="el-icon-close" size="small" type="danger" @click="addBuild(index)"> </el-button>
				</div>
				<el-row>
					<el-col :span="12">
						<el-form-item label="一次分区:" prop="tower">
							<el-input v-model="item.tower" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-row>
							<el-col class="ml20" :span="2">
								<el-button class="el-icon-plus" type="primary" size="small" @click="addDev(index)">添加二次分区</el-button>
							</el-col>
						</el-row>
						<el-row class="mt10">
							<el-col :span="12">
								<el-form-item label="二次分区:" prop="tier">
									<div class="flex  mt10" v-for="(it, idx) in item.area" :key="idx">
										<el-input v-model="it.value" @change="selTier(index)"></el-input>
										<el-col :span="2" class="ml10">
											<el-button class="el-icon-minus" type="primary" size="small" @click="addDev(index, idx, 1)"> </el-button>
										</el-col>
									</div>
								</el-form-item>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
			</el-row>

			<div class="btn-box center">
				<el-button type="primary" class="l-btn" @click="onSubmit" v-hasPermi="['drillplan:planJianzhu:addAndUpdate']">保存</el-button>
				<!-- <el-button type="primary" @click="$router.back()">返回</el-button> -->
			</div>
		</el-form>
		<el-backtop target=".common-body-style"></el-backtop>
	</div>
</template>

<script>
	import OSS from "ali-oss";

	export default {
		components: {},
		data() {
			return {
				partition: {
					area: [{ value: "" }],
					companyNum: "",
					tier: "",
					tower: "",
				},
				form: {
					companyNum: this.$local.get("company").c_company_num,
					planJianzhuList: [
						{
							companyNum: this.$local.get("company").c_company_num,
							tier: "",
							tower: "",
						},
					],
				},
				fileList: [],
			};
		},
		created() {
			// 获取
			let companyNum = this.$local.get("company").c_company_num;
			this.$get(`/drillplan/planJianzhu/planArea/${companyNum}`).then((res) => {
				var form = res.data;
				form.map((item) => {
					item.area = []; // 存放 tier  隔离
					item.tier.split(",");
					if (item.tier) {
						item.tier.split(",").map((it) => {
							item.area.push({ value: it });
						});
					}
				});
				this.form.planJianzhuList = form; // 赋值
				console.log("🚀 ~ file: builddevice.vue:111 ~ this.$get ~ this.form.planJianzhuList:", this.form.planJianzhuList);
			});
		},
		methods: {
			addDev(index, ind, state) {
				if (state) {
					this.form.planJianzhuList[index].area.splice(ind, 1);
				} else {
					this.form.planJianzhuList[index].area.push({ value: "" });
				}
				this.selTier(index);
			},
			// 转换tier
			selTier(index) {
				var str = "";
				this.form.planJianzhuList[index].area.map((item) => {
					str += "," + item.value;
				});
				this.form.planJianzhuList[index].tier = str.substr(1);
			},
			addBuild(index) {
				index >= 0
					? this.form.planJianzhuList.splice(index, 1)
					: this.form.planJianzhuList.unshift({
							area: [{ value: "" }],
							tier: "",
							// imageName: "",
							tower: "",
					  });
			},
			//上传
			filechange() {},
			remove(file, index) {
				this.form.planJianzhuList[index].imageName = "";
			},
			upload(val, index) {
				let client = new OSS(this.$bus.config.ossConfig);
				let file = val.file;
				let id = this.$bus.config.plan + "/t" + Date.now() + "s" + file.size + "/" + file.name;
				this.$set(this.fileList, id, {
					name: file.name,
					size: file.size,
					uploading: true,
					time: 0,
					progress: 0,
					key: id,
					client: client,
				});
			},
			onSubmit() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						this.save();
					} else {
						return false;
					}
				});
			},
			save() {
				let loading = this.$loading({ background: "rgba(0, 0, 0, 0.6)" });
				this.$post("/drillplan/planJianzhu/addAndUpdate", this.form)
					.then((res) => {
						// this.$message.success("保存成功");
						this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
						this.$router.back();
						loading.close();
					})
					.catch((err) => {
						loading.close();
					});
			},
		},
	};
</script>

<style scoped></style>
